<template>
    <div class="table-sorter">
        Sort By
        <span class="current-sort-label" :class="currentSortLabelCssClass">
            <span
                class="sort-label"
                @click.prevent.stop="showTooltip = !showTooltip"
                >{{ currentSortable.title }}</span
            >
            <span
                class="sort-direction"
                @click.prevent.stop="switchSortDirection"
            >
                <svg
                    class="sort-direction-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <path
                        class="fill-none"
                        fill="none"
                        d="M0 0h24v24H0V0z"
                    ></path>
                    <path
                        d="M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
                    ></path>
                </svg>
            </span>
        </span>

        <tooltip
            v-if="showTooltip"
            css-class="table-sorter-tooltip"
            placement="bottom-start"
            :parent="$el.querySelector('.current-sort-label')"
        >
            <ul>
                <table-sorter-item
                    v-for="header in sortables"
                    :header="header"
                    :current-sort="currentSort"
                    :key="header.key"
                    @sort="sort"
                />
            </ul>
        </tooltip>
    </div>
</template>

<script>
import TableSorterItem from 'src/components/TableSorterItem';

export default {
    props: ['sortables', 'currentSort', 'currentSortDirection'],
    data() {
        return {
            showTooltip: false,
        };
    },
    components: {
        TableSorterItem,
    },
    computed: {
        currentSortable() {
            return this.sortables.filter(
                header => header.key === this.currentSort,
            )[0];
        },
        currentSortLabelCssClass() {
            return this.currentSortDirection === 'asc'
                ? 'sort-asc'
                : 'sort-desc';
        },
    },
    methods: {
        sort(header) {
            this.$emit('sort', header.key);
            this.showTooltip = false;
        },
        switchSortDirection() {
            this.$emit('sort', this.currentSort);
            this.showTooltip = false;
        },
    },
};
</script>
